export const RESET_PERSONALIZATION_CONTENT_ISFETCHING =
  'RESET_PERSONALIZATION_CONTENT_ISFETCHING';
export const GET_PERSONALIZATION_CONTENT_REQUEST =
  'GET_PERSONALIZATION_CONTENT_REQUEST';
export const GET_PERSONALIZATION_CONTENT_SUCCESS =
  'GET_PERSONALIZATION_CONTENT_SUCCESS';
export const PERSONALIZATION_CONTENT_OBJECT_REQUESTING =
  'PERSONALIZATION_CONTENT_OBJECT_REQUESTING';
